import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import { DisclaimerBanner, Navbar, Footer } from "./components/site/Layout";
import { CartDrawer } from "./components/site/CartDrawer";
import { ProtectedRoute } from "./components/site/ProtectedRoute";
import Landing from "./pages/Landing";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";
import { Login, Register, ForgotPassword, ResetPassword } from "./pages/Auth";
import Questionnaire from "./pages/Questionnaire";
import PlanPage from "./pages/PlanPage";
import OrderPage from "./pages/OrderPage";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/Admin";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <div className="min-h-screen flex flex-col">
            <DisclaimerBanner />
            <Navbar />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/shop/:id" element={<ProductDetail />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/questionnaire" element={<Questionnaire />} />
                <Route path="/onboarding" element={<Questionnaire />} />
                <Route path="/plan/:id" element={<ProtectedRoute><PlanPage /></ProtectedRoute>} />
                <Route path="/orders/:id" element={<ProtectedRoute><OrderPage /></ProtectedRoute>} />
                <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute admin><Admin /></ProtectedRoute>} />
              </Routes>
            </main>
            <Footer />
            <CartDrawer />
            <Toaster position="top-center" richColors />
          </div>
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
